import React from 'react';

const TextHighlighter = ({ text = '', searchText = '' }) => {
    if (!searchText.trim()) {
        return React.createElement("span", null, text);
    }
    const regex = new RegExp(`(${searchText})`, 'gi');
    const parts = text.split(regex);
    return (React.createElement("span", null, parts.filter(String).map((part, index) => 
    // eslint-disable-next-line react/no-array-index-key
    regex.test(part) ? React.createElement("mark", { key: index }, part) : React.createElement("span", { key: index }, part))));
};

export { TextHighlighter as T };
//# sourceMappingURL=TextHighlighter-ZyVmLG-I.js.map
